export function getdata() {
	var obj = {
		headData: [{
				title: "模板名称",
				prop: "name",
				width: 160,
				align: "left"
			},
			{
				title: "模板用途",
				prop: "purpose",
				width: 160,
				align: "left"
			},
			{
				title: "创建时间",
				prop: "createTime",
				width: 160,
				align: "left"
			},
			{
				title: "上传时间",
				prop: "createTime",
				width: 160,
				align: "left"
			},
			{
				title: "最近操作人",
				prop: "updateBy",
				width: 80,
			},
			{
				title: "操作",
				prop: "cz",
				custom: true
			},
		],
		headDatamb: [{
				title: "类别",
				prop: "columnType",
				custom: true
			},
			{
				title: "标准字段名称",
				prop: "name",
				align: "left",
				custom: true
			},
			{
				title: "填表说明（需用户注意）",
				prop: "explain",
			},
			{
				title: "取值方式",
				prop: "dicData",
				align: "left",
				custom: true,
				width: "450px"
			},
			{
				title: "列名称",
				prop: "tableColumnName",
				custom: true
			},
			{
				title: "数据起始行示例",
				prop: "example",
				align: "left",
				custom: true
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
